// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.boarding-tutorial-container h1 {
  font-size: 32px;
  font-weight: 700;
}
.boarding-tutorial-container h2 {
  font-size: 24px;
  font-weight: 700;
  padding: 20px 0;
}
.boarding-tutorial-container header {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin: 0 auto;
  padding: 20px 0 10px 0;
  max-width: max-content;
}
.boarding-tutorial-container header img {
  width: 100%;
  height: auto;
}
.boarding-tutorial-container header small {
  float: right;
  position: relative;
  font-size: 12px;
}
.boarding-tutorial-container .mirakl-video-container {
  margin: 0 auto;
  position: relative;
  overflow: hidden;
  width: 90%;
  padding-top: 40%;
  top: 0;
}
.boarding-tutorial-container .mirakl-video-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/pages/Boarding/Boarding.scss"],"names":[],"mappings":"AACE;EACE,eAAA;EACA,gBAAA;AAAJ;AAEE;EACE,eAAA;EACA,gBAAA;EACA,eAAA;AAAJ;AAEE;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,cAAA;EACA,sBAAA;EACA,sBAAA;AAAJ;AACI;EACE,WAAA;EACA,YAAA;AACN;AACI;EACE,YAAA;EACA,kBAAA;EACA,eAAA;AACN;AAEE;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,gBAAA;EACA,MAAA;AAAJ;AACI;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;AACN","sourcesContent":[".boarding-tutorial-container {\n  h1 {\n    font-size: 32px;\n    font-weight: 700;\n  }\n  h2 {\n    font-size: 24px;\n    font-weight: 700;\n    padding: 20px 0;\n  }\n  header {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    margin: 0 auto;\n    padding: 20px 0 10px 0;\n    max-width: max-content;\n    img {\n      width: 100%;\n      height: auto;\n    }\n    small {\n      float: right;\n      position: relative;\n      font-size: 12px;\n    }\n  }\n  .mirakl-video-container {\n    margin: 0 auto;\n    position: relative;\n    overflow: hidden;\n    width: 90%;\n    padding-top: 40%;\n    top: 0;\n    iframe {\n      position: absolute;\n      top: 0;\n      left: 0;\n      bottom: 0;\n      right: 0;\n      width: 100%;\n      height: 100%;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
